import AccountingDetails from './AccountingDetails'
export default AccountingDetails
